import AutenticacaoContext from './AutenticacaoContext';

const AutenticacaoConsumer = AutenticacaoContext.Consumer;

export default AutenticacaoConsumer;